import api from './axios';
import type { Product } from '../types/product';

export interface SaleProductCategory {
  id: number;
  name: string;
  nameZh: string;
  nameCn: string;
  description: string;
  descriptionZh: string;
  descriptionCn: string;
  isActive: boolean;
  parentId: number | null;
  createdAt: string;
  imageUrl: string | null;
}

export interface SaleProductsResponse {
  products: Product[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface SaleProductsParams {
  page: number;
  limit: number;
  sortBy: 'new' | 'popular' | 'price_low' | 'price_high';
  categoryId?: number;
}

export const saleProductsApi = {
  // Get sale product categories
  getSaleProductCategories: async (): Promise<SaleProductCategory[]> => {
    try {
      const response = await api.get('/api/shop/sale-products/categories');
      return response.data;
    } catch (error) {
      console.error('Error fetching sale product categories:', error);
      return [];
    }
  },

  // Get sale products with optional category filter
  getSaleProducts: async (params: SaleProductsParams): Promise<SaleProductsResponse> => {
    try {
      const queryParams = new URLSearchParams({
        page: params.page.toString(),
        limit: params.limit.toString(),
        sortBy: params.sortBy,
        ...(params.categoryId && { categoryId: params.categoryId.toString() }),
      });

      const response = await api.get(`/api/shop/sale-products?${queryParams}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching sale products:', error);
      throw error;
    }
  },
};
